module.exports = __webpack_public_path__ + "img/btn_tab_5@3x.ef2f2f11.png";